import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ONLStartWalletSession, ONLWalletSession, ONLWalletSessionRequest, ONLWalletSessionResponse, PPIWalletSessionRequest, PPIWalletSessionResponse } from '../models/session.model';
import { Observable, BehaviorSubject, EMPTY } from 'rxjs';
import { map, tap, switchMap } from 'rxjs/operators';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { ScriptService } from './script.service';
import { UserService } from './user.service';

interface SummaryRequestPayload {
  walletID: string;
  walletRole: string;
  sessionID: string;
}

@Injectable({
  providedIn: 'root'
})

export class SessionService {
   // apiURL:string ='';
 //  apiURL:string = "https://ib-wallet-dev-api.azurewebsites.net/api/Authentication/ONLValidateWalletSession?sessionId=";
    apiURL:string = ApiEndpoints.sessionjwt;
 
   //apiURL:string = ApiEndpoints.
     sessionobj:ONLWalletSession=new ONLWalletSession();

     private displayNameSource = new BehaviorSubject<string>('Guest');
     private displayProductTypeSource = new BehaviorSubject<string>('');
     private displayBillingTypeSource = new BehaviorSubject<string>('');
     private displayobjectUIDSource = new BehaviorSubject<string>('N');

  constructor(
    private http:HttpClient, 
    private scriptService:ScriptService,
    private userService: UserService // Inject UserService
  ) { 
    // Restore state from SessionStorage on load
    const storedBilliant = sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    this.isBilliantSource.next(storedBilliant);
   }

private isBilliantSource = new BehaviorSubject<boolean>(false);
isBilliant$ = this.isBilliantSource.asObservable();

// Helper to check instantly without subscription (optional, but useful for logic)
getIsBilliantValue(): boolean {
  return this.isBilliantSource.getValue();
}

// --- This method stores the isPPI session state ---
private isPPISession: boolean = false; // default is false

setIsPPI(value: boolean): void {
 this.isPPISession = value;
 sessionStorage.setItem('isPPI', String(value)); // optional: persist in storage if needed
}

isPPI(): boolean {
 return this.isPPISession || sessionStorage.getItem('isPPI') === 'true'; // fallback to storage
}

fetchSessionObject(sessionId: string, isPPI: boolean): Observable<ONLWalletSessionResponse | PPIWalletSessionResponse> {
   let sessionRequest: ONLWalletSessionRequest | PPIWalletSessionRequest;

   if (isPPI) { // Logic for PPI API call
     this.setIsPPI(true); // Set the internal flag
     this.apiURL = ApiEndpoints.ppiSessionjwt; // Use the PPI session validation URL
     sessionRequest = new PPIWalletSessionRequest();
     console.log("PPI session ID detected (via flag):", sessionId);
   } else { // Logic for ONL API call
     this.setIsPPI(false); // Set the internal flag
     this.apiURL = ApiEndpoints.sessionjwt; // Use the ONL session validation URL
     sessionRequest = new ONLWalletSessionRequest();
     console.log("ONL session ID assumed:", sessionId);
   }

   // Common request parameters for both ONL and PPI
   sessionRequest.sessionId=sessionId;
  //  sessionRequest.secret=ApiEndpoints.secret;
  //  sessionRequest.user=ApiEndpoints.userIn;
  //  sessionRequest.pass=ApiEndpoints.passwordIn;

  return this.http.post<ONLWalletSessionResponse | PPIWalletSessionResponse>(this.apiURL,sessionRequest).pipe(
    tap((res: ONLWalletSessionResponse | PPIWalletSessionResponse) => {
      this.sessionobj = {...res};
      console.log("sessionobj : ", JSON.stringify(this.sessionobj));
      sessionStorage.setItem('SessionID', sessionId); // Store the raw session ID from the URL

      if (isPPI) { // Logic for PPI session response handling
          const ppiRes = res as PPIWalletSessionResponse;
          this.storeSessionData(ppiRes); // Call centralized storage for PPI
          console.log("PPIRes : ", ppiRes);
        } else { // Logic for ONL session response handling
          const onlRes = res as ONLWalletSessionResponse;
          this.storeSessionData(onlRes); // Call centralized storage for ONL
          console.log("ONLRes : ", onlRes);
        }

      // --- CRITICAL FIX: Pass all required data to pendoInit ---
      try {
        // Get current values from BehaviorSubjects (they should be updated by storeSessionData)
        const isBilliant = this.isBilliantSource.getValue();
        
        const pendoData = {
          objectUID: this.displayobjectUIDSource.getValue(),
          displayName: this.displayNameSource.getValue(),
          walletId: (res.walletID || 'anonymous'), // Use walletID from response, fallback to anonymous
          walletRole: (res.walletRole || 'guest'), // Use walletRole from response, fallback to guest
          productType: this.displayProductTypeSource.getValue(),
          billingType: this.displayBillingTypeSource.getValue(),
          currentSessionId: sessionId, // Pass the current session ID
        };
        this.scriptService.pendoInit(isPPI, pendoData, isBilliant); // <-- Pass the isPPI flag AND the data object
      } catch (pendoError) {
        console.error('SessionService tap: pendoInit threw a SYNCHRONOUS error and was caught!', pendoError);
        throw pendoError; // Re-throw to propagate error to AuthGuard's catchError
      }

    }),
    map((res) => res)// Ensure the response is returned
    
  );
}

  getDisplayName(): Observable<string> {
    return this.displayNameSource.asObservable();
  }

  getProductType(): Observable<string> {
    return this.displayProductTypeSource.asObservable();
  }

  getBillingType(): Observable<string> {
    return this.displayBillingTypeSource.asObservable();
  }

  getObjectUID(): Observable<string>{
    return this.displayobjectUIDSource.asObservable();
  }


private storeSessionData(data: ONLWalletSessionResponse | PPIWalletSessionResponse): void {
  sessionStorage.setItem('WalletID', JSON.stringify(data.walletID));
  sessionStorage.setItem('WalletRole', JSON.stringify(data.walletRole));
  sessionStorage.setItem('sessionapimessage', JSON.stringify(data.message));
  sessionStorage.setItem('headers', data.dpatJWT);
  sessionStorage.setItem('walletheaders', data.ibJWT);

  if ('onlStartWalletSession' in data && data.onlStartWalletSession) {
    sessionStorage.setItem('ONLWalletSession', JSON.stringify((data as ONLWalletSessionResponse).onlStartWalletSession));
    sessionStorage.setItem('policyNumber', data.onlStartWalletSession.productSystemIdentifier1 || '');
    sessionStorage.removeItem('PPIWalletSession');

    const onlSessionData = (data as ONLWalletSessionResponse).onlStartWalletSession;
    // New logic for Billiant
    // Check if productSystem is 'Billiant'
    const isBilliant = onlSessionData?.productSystem?.toLowerCase() === 'billiant';
    this.isBilliantSource.next(isBilliant);
    sessionStorage.setItem('isBilliant', String(isBilliant)); // Persist for page refresh

    this.displayNameSource.next(onlSessionData?.displayName || 'Guest');
    this.displayProductTypeSource.next(onlSessionData?.productType || '');
    this.displayBillingTypeSource.next(onlSessionData?.billingType || '');
    this.displayobjectUIDSource.next(onlSessionData?.objectUID || null);

  } else if ('ppiStartWalletSession' in data && (data as any).ppiStartWalletSession) {
    sessionStorage.removeItem('ONLWalletSession');
    this.isBilliantSource.next(false);
    sessionStorage.removeItem('isBilliant');

    const ppiSessionData = (data as any).ppiStartWalletSession;
   // sessionStorage.setItem('PPIWalletSession', JSON.stringify((data as any).ppiStartWalletSession));
   sessionStorage.setItem('PPIWalletSession', JSON.stringify(ppiSessionData));

   const userID = ppiSessionData?.userIdentifier1 || '';
    const customerID = ppiSessionData?.productSystemIdentifier1 || '';

    sessionStorage.setItem('PPIUserID', userID);
    sessionStorage.setItem('PPICustomerID', customerID);

 
    this.displayNameSource.next(ppiSessionData?.displayName || 'Guest');
    this.displayProductTypeSource.next(ppiSessionData?.productType || '');
    this.displayBillingTypeSource.next(ppiSessionData?.billingType || '');
    this.displayobjectUIDSource.next(ppiSessionData?.objectUID || null);
  } else {
    sessionStorage.removeItem('ONLWalletSession');
    sessionStorage.removeItem('PPIWalletSession');
    sessionStorage.removeItem('PPIUserID');
    sessionStorage.removeItem('PPICustomerID');
    this.displayNameSource.next('Guest');
    this.displayProductTypeSource.next('');
    this.displayBillingTypeSource.next('');
    this.displayobjectUIDSource.next(null);
  }
}


  private getSessionData(): ONLStartWalletSession | null {
    const sessionDataString = sessionStorage.getItem('ONLWalletSession');
    if (sessionDataString) {
      return JSON.parse(sessionDataString);
    } else {
      return null;
    }
  }

 public handleNextGenSession(data: any): void {
    console.log('🔄 SessionService: Hydrating session from Next Gen API', data);

    if (!data) {
        console.warn('⚠️ Warning: Received empty data object in handleNextGenSession');
        return;
    }

    // 1. Store Session ID (Check both casing variations)
    // The API returns 'sessionId' (camelCase), but the app might expect 'SessionID' or 'sessionID'
    const validSessionId = data.sessionID || data.sessionId;

    if (validSessionId) {
        sessionStorage.setItem('SessionID', validSessionId);
    } else {
        console.warn('⚠️ Warning: No valid session ID found in Auth0 response!', data);
    }

    // 2. Store Wallet ID
    const validWalletId = data.walletID || data.walletId;
    if (validWalletId) {
        // Store as stringified JSON to match legacy behavior if needed, 
        // or just the string if your app has been updated to handle it.
        sessionStorage.setItem('WalletID', JSON.stringify(validWalletId));
    }

    if (data.walletRole) {
        sessionStorage.setItem('WalletRole', JSON.stringify(data.walletRole));
    }

    // 3. T&C Logic (Crucial for Modal)
    // We store "0" or "1" directly as a string
    if (data.tcAcceptance !== undefined && data.tcAcceptance !== null) {
        sessionStorage.setItem('TCAcceptance', String(data.tcAcceptance));
    }

    // 4. Handle Display Name
    // Fallback logic: displayName -> userFirstName -> email -> 'Valued Customer'
    let name = data.displayName || data.userFirstName;
    
    if (!name && data.userEmail) {
        // Extract name from email (e.g. "ptngus09" from "ptngus09@mailnesia...")
        name = data.userEmail.split('@')[0]; 
    }
    
    this.displayNameSource.next(name || 'Valued Customer');

    // 5. Token Handling
    // Map the incoming token to 'walletheaders' for your Interceptor
    const token = data.dpatToken || data.headers || data.ibJWT;
    if (token) {
        sessionStorage.setItem('walletheaders', token);
    }
    
    // 6. Reset Legacy/Other Flags
    // Ensure the UI knows this is NOT a Billiant or PPI session
    this.isBilliantSource.next(false);
    this.setIsPPI(false); 
    
    // Optional: Log completion
    console.log('✅ Session Hydration Complete. SessionID:', validSessionId ? 'Saved' : 'Missing');
  }


}